import EditRecordItem from '@/component/EditRecordItemV2';
import SpeakerAvatar from '@/pages/Voice/SpearkerAvatar';
import { ReactNode } from 'react';
import { IPG } from '@/types/summary';
import { IEditRecordParams, IMergeRecordParams } from '@/types/record';

export interface IProps {
  speakerName: string;
  useDefaultIcon?: boolean;
  avatarIndex?: number;
  recordTime?: string;
  content?: ReactNode;
  speaking?: boolean;
  avatar?: ReactNode;
  unstableContent?: string;
  unstableTranslateContent?: string;
  record?: IPG;
  pi?: string; // 段落ID，用于编辑操作
  editable?: boolean; // 是否可编辑
  isTrans?: boolean; // 是否是译文
  onEditRecord?: (params: IEditRecordParams) => Promise<void>; // 流名称
  onMergeRecord?: (params: IMergeRecordParams) => void;
  onModifySpeakerName?: (updatedParas: IPG[], editRoleType: 'ONE' | 'BATCH') => Promise<void>; // 修改发言人
  onSpeakerPopoverChange?: (visible: boolean) => void; // 发言人弹窗状态变化回调
}

const ContentItem = ({
  speakerName,
  useDefaultIcon,
  recordTime,
  avatarIndex,
  content,
  speaking = false,
  avatar,
  unstableContent,
  record,
  pi,
  editable,
  isTrans,
}: IProps) => {

  return (
    <div className="text-3.5">
      <div className="flex items-center text-3 pb-2.5 relative">
        {avatar ? (
          avatar
        ) : (
          <SpeakerAvatar
            speakerName={speakerName}
            avatarIndex={avatarIndex}
            useDefaultAvatarIcon={useDefaultIcon}
            className="size-6 mr-2"
            fontSize="0.5rem"
          />
        )}
        <div className="text-mx-quaternary mr-2">{isTrans ? speakerName.replace('发言人', 'Speaker') : speakerName}</div>
        <div className="text-mx-quaternary">{recordTime}</div>
      </div>
      <div
        className={`b-1 ${speaking && unstableContent ? 'text-#30343C' : speaking && !unstableContent ? 'text-#30343C4D' : 'text-#30343C'
          } lh-7 `}
      >
        {record && pi ? (
          <EditRecordItem
            record={record}
            isTrans={isTrans}
            handleEdit={() => { }}
            editable={editable}
          />
        ) : (
          content
        )}
        {speaking && <span>{unstableContent || '等待发言人说话...'}</span>}
      </div>
    </div>
  );
};

export default ContentItem;